var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-calendar',{attrs:{"color":"#29BEBC","show-title":false,"show-confirm":false,"min-date":_vm.minDate,"max-date":_vm.maxDate},on:{"confirm":_vm.onConfirm},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }